import React from "react";

interface IAncestorProviderProps {
	ancestors: string[];
}

const AncestorContext = React.createContext<IAncestorProviderProps>({ancestors: []});

const AncestorProvider: React.SFC<any> = ({children, ...props}) => {
	return (
		<AncestorContext.Consumer>
			{(context) => (
				<AncestorContext.Provider value={{ancestors: [...context.ancestors, props.instance]}}>
					{/* React.Children.map(props.children, (child) => React.cloneElement(child as any, {ancestors: context.ancestors})) */}
					{children({...props, ancestors: context.ancestors})}
				</AncestorContext.Provider>
			)}
		</AncestorContext.Consumer>
	);
};

export default AncestorProvider;



// WEBPACK FOOTER //
// ./src/core/components/editor/AncestorProvider.tsx